
































import Vue, { PropType } from 'vue';

export type DataType = {
  innerValue: string|null;
  isShowSelectMenu: boolean;
}

export type optionsType = {
  value: number;
  text: string;
};

export default Vue.extend({
  name: 'GAddButton',
  props: {
    selectName: { type: String as PropType<string>, required: true },
    size: { type: String as PropType<string>, default: 'small' },
    options: { type: Array as PropType<optionsType[]>, required: true },
    disabled: { type: Boolean as PropType<boolean>, default: false },
  },
  data(): DataType {
    return {
      innerValue: null,
      isShowSelectMenu: false,
    };
  },
  watch: {
    innerValue(val: string) {
      if (this.innerValue !== null) {
        this.isShowSelectMenu = !this.isShowSelectMenu;
        this.$emit('input', val);
      }
    },
    isShowSelectMenu(): void {
      if (!this.isShowSelectMenu) this.innerValue = null;
    },
  },
  methods: {
    setInnerValue(val: string) {
      this.innerValue = val;
    },
  },
});
